import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'jalali-moment';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const RequestsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('requests'), link: '/requests-list' },
		{ title: t('list') }
	];

	const [requests, setRequests] = useState([]);
	let requestsListData = {
		head: [t('creation_date'), t('user'), t('category'), t('status'), t('operation')],
		body: requests.map(request => [
			moment(request.create_date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			<Link className='' to={`/users-edit/${request.user_id_information.user_id}`} target="_blank">
				{request.user_id_information.user_fullname}
			</Link>,
			<Link className='' to={`/request-categories-edit/${request.requestcategory_id_information.requestcategory_id}`} target="_blank">
				{request.requestcategory_id_information.requestcategory_name}
			</Link>,
			<span className={"badge rounded-pill p-2 badge-subtle-" + (request.request_state === 0 ? 'success' : request.request_state === 3 ? 'warning' : request.request_state === 1 ? 'primary' : 'danger')}>
				{request.request_state === 0 ? t('pending') : request.request_state === 3 ? t('canceled') : request.request_state === 1 ? t('confirmed') : t('failed')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/requests-edit/${request.request_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['ltr', 'rtl', 'rtl', '', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchRequestCategory, setSearchRequestCategory] = useState(null);
	const [searchRequestStatus, setSearchRequestStatus] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getRequests = async () => {
		let body = {
			requestcategory_id: searchRequestCategory,
			request_state: searchRequestStatus,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/requests/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_requests);
				setRequests(response.data.requests);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterRequests = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let categoryID = event.target.searchRequestCategory.value.trim() || null;
		let status = event.target.searchRequestStatus.value.trim() || null;
		setSearchRequestCategory(categoryID);
		setSearchRequestStatus(status);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};

	const [requestCategories, setRequestCategories] = useState([]);
	const getRequestCategories = async () => {
		let body = {
			requestcategory_name: null,
			page: 1,
			count: 1000000
		};
		let response = await _post('/requestcategories/admin/getAll', body);
		switch(response.code){
			case 200:
				setRequestCategories(response.data.requestcategories.map(item => {
					return {
						key: item.requestcategory_name,
						value: item.requestcategory_id
					}
				}));
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	const requestStatusList = [
		{ key: t('pending'), value: 0 },
		{ key: t('canceled'), value: 3 },
		{ key: t('confirmed'), value: 1 },
		{ key: t('failed'), value: 2 }
	];

	useEffect(() => {
		getRequestCategories();
	}, []);

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getRequests();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('requests')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterRequests}>
						<div className="row gx-2">
							<FormField type="select" fieldKey="searchRequestCategory" title={t('category')} value={searchRequestCategory} selectItems={requestCategories} isSearch={true} />
							<FormField type="select" fieldKey="searchRequestStatus" title={t('status')} value={searchRequestStatus} selectItems={requestStatusList} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('requests')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={requestsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default RequestsList;
